__turbopack_context__.v({
  "combinedHeading": "work-author-slider-module-scss-module__WxRlZq__combinedHeading",
  "description": "work-author-slider-module-scss-module__WxRlZq__description",
  "followButton": "work-author-slider-module-scss-module__WxRlZq__followButton",
  "followButtonShell": "work-author-slider-module-scss-module__WxRlZq__followButtonShell",
  "hasBackground": "work-author-slider-module-scss-module__WxRlZq__hasBackground",
  "headingGroup": "work-author-slider-module-scss-module__WxRlZq__headingGroup",
  "headingRow": "work-author-slider-module-scss-module__WxRlZq__headingRow",
  "narrowHeading": "work-author-slider-module-scss-module__WxRlZq__narrowHeading",
  "root": "work-author-slider-module-scss-module__WxRlZq__root",
  "titleDivider": "work-author-slider-module-scss-module__WxRlZq__titleDivider",
  "u-animation-bounce": "work-author-slider-module-scss-module__WxRlZq__u-animation-bounce",
  "wideHeading": "work-author-slider-module-scss-module__WxRlZq__wideHeading",
});
